import {Component} from "react";
import "./DestinationStyle.css";
import Radha from "../assets/radha.jpg";
import Radha2 from "../assets/radha2.jpeg";


class DestinationData extends Component{
    render(){
        return(
            <div className={this.props.className}>
          <div className="des-text">
            <h2>{this.props.heading}</h2>
            <p>
              {this.props.text}</p>
          </div>
          <div className="image">
            <img
              alt="Radhanagar Beach"
              src={this.props.img1}
            >
            </img>
            <img
              alt="Radhanagar Beach"
              src={this.props.img2}
            >
            </img>
          </div>
        </div>
        )
    }
}

export default DestinationData;